__turbopack_context__.v({
  "root": "PublishedBadge-module-scss-module__M9DL8q__root",
});
